import { __awaiter } from "tslib";
import { fetchAIHubEnabled } from '@office-start/ai-hub-config-service';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { fetchBCAIS, fetchCopilotEligible, } from '@office-start/copilot-route-service';
import { fetchFeatureGates, getFeatureGates, } from '@office-start/feature-gates-service';
import { fetchFeatureSettings, getFeatureSettings, } from '@office-start/feature-settings-service';
import { defaultReferrer, referrerHostUrls } from '../constants';
// TODO: merge the two URLs into one
const COPILOT_BASE_URL_COPILOT_ROUTE = 'https://outlook.office.com/hosted/semanticoverview{userRouting}?{localeAndHostName}{referrer}{navigationType}{sessionId}{aihub}hostApp=hub&isanonymous=true&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage';
const COPILOT_BASE_URL_NON_COPILOT_ROUTE = 'https://outlook.office.com/hosted/semanticoverview{userRouting}?{localeAndHostName}{referrer}{navigationType}{sessionId}{aihub}hostApp=hub&isanonymous=true&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage';
export const getCopilotBaseUrl = (isBCAISContext, isEligibleForAnyCopilot) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const featureSettingsResult = getFeatureSettings();
    const featureSettings = (featureSettingsResult === null || featureSettingsResult === void 0 ? void 0 : featureSettingsResult.result)
        ? featureSettingsResult
        : yield fetchFeatureSettings();
    const featureGatesResult = getFeatureGates();
    const { result: featureGates } = (featureGatesResult === null || featureGatesResult === void 0 ? void 0 : featureGatesResult.result)
        ? featureGatesResult
        : yield fetchFeatureGates();
    const copilotMode = (_b = (_a = featureSettings.result) === null || _a === void 0 ? void 0 : _a.copilot) === null || _b === void 0 ? void 0 : _b.mode;
    const isCopilotEligible = isEligibleForAnyCopilot || (yield fetchCopilotEligible());
    const isBCAIS = isBCAISContext || (yield fetchBCAIS());
    /*
    eligibility mask's bit interpretation:
    - 0th bit: BCE eligibility
    - 1st bit: BCB eligibility
    They can be independently set, to represent the eligibility of the user for the respective tabs
    */
    let baseUrl = getCopilotBaseUrlInternal(copilotMode, featureGates, yield fetchAIHubEnabled());
    const isCopilotRoute = isCopilotPath();
    // apply QPs for eligibility (for Mode A copilot path, and always for Mode B)
    if ((isCopilotRoute && copilotMode === 'ModeA') ||
        copilotMode === 'ModeB') {
        const qp = `&worktab=${isBCAIS ? 1 : 0}&webtab=${isCopilotEligible ? 1 : 0}`;
        baseUrl = `${baseUrl}${qp}`;
    }
    return baseUrl;
});
function getCopilotBaseUrlInternal(copilotMode, featureGates, isAIhub) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let bizchatCopilotUrl = COPILOT_BASE_URL_COPILOT_ROUTE;
    let bizchatNonCopilotUrl = COPILOT_BASE_URL_NON_COPILOT_ROUTE;
    const referrerParamKey = '{referrer}';
    const navigationTypeParamKey = '{navigationType}';
    const aihubParamKey = '{aihub}';
    const passReferrerHostAndNavigationType = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _a === void 0 ? void 0 : _a.immersiveBizchatM365AppReferrerHostAndNavigationTypeChangesEnabled) !== null && _b !== void 0 ? _b : false;
    if (passReferrerHostAndNavigationType) {
        let referrer = getReferrer();
        if (!(referrer === null || referrer === void 0 ? void 0 : referrer.length)) {
            referrer = window.location.href;
        }
        [bizchatCopilotUrl, bizchatNonCopilotUrl] = addParams([referrerParamKey, navigationTypeParamKey], [
            `${referrerParamKey.slice(1, -1)}=${referrer}`,
            `${navigationTypeParamKey.slice(1, -1)}=${((_c = AppbarConnectorService.getInstance()) === null || _c === void 0 ? void 0 : _c.tileChanged)
                ? 'appbar'
                : 'direct'}`,
        ], bizchatCopilotUrl, bizchatNonCopilotUrl);
    }
    else {
        [bizchatCopilotUrl, bizchatNonCopilotUrl] = removeParams([navigationTypeParamKey], bizchatCopilotUrl, bizchatNonCopilotUrl);
        const referrerQP = `referrer=${isCopilotPath() || copilotMode === 'ModeB' ? 'copilot' : 'chat'}`;
        [bizchatCopilotUrl, bizchatNonCopilotUrl] = addParams([referrerParamKey], [referrerQP], bizchatCopilotUrl, bizchatNonCopilotUrl);
    }
    if (isAIhub) {
        [bizchatCopilotUrl, bizchatNonCopilotUrl] = addParams([aihubParamKey], ['aihub=true'], bizchatCopilotUrl, bizchatNonCopilotUrl);
    }
    else {
        [bizchatCopilotUrl, bizchatNonCopilotUrl] = removeParams([aihubParamKey], bizchatCopilotUrl, bizchatNonCopilotUrl);
    }
    const enabledUrlChange = (_e = (_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _d === void 0 ? void 0 : _d.immersiveBizchatM365AppUrlChangeEnabled) !== null && _e !== void 0 ? _e : false;
    if (enabledUrlChange) {
        // Wiki - https://docs.substrate.microsoft.net/docs/performance/Latency/Routing/Routing-best-practices.html?uid=routing-best-practices
        bizchatCopilotUrl = bizchatCopilotUrl.replace('{userRouting}', "/Users('OID:{user.id}@{user.tenant.id}')");
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('{userRouting}', "/Users('OID:{user.id}@{user.tenant.id}')");
        bizchatCopilotUrl = bizchatCopilotUrl.replace('&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage', '');
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage', '');
    }
    else {
        bizchatCopilotUrl = bizchatCopilotUrl.replace('{userRouting}', '');
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('{userRouting}', '');
    }
    const passLocaleAndHostName = (_g = (_f = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _f === void 0 ? void 0 : _f.immersiveBizchatM365AppLocaleAndHostNameChangeEnabled) !== null && _g !== void 0 ? _g : false;
    if (passLocaleAndHostName) {
        bizchatCopilotUrl = bizchatCopilotUrl.replace('{localeAndHostName}', 'culture={app.locale}&hostName={app.host.name}&hostClientType={app.host.clientType}&');
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('{localeAndHostName}', 'culture={app.locale}&hostName={app.host.name}&hostClientType={app.host.clientType}&');
    }
    else {
        bizchatCopilotUrl = bizchatCopilotUrl.replace('{localeAndHostName}', '');
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('{localeAndHostName}', '');
    }
    const passSessionId = (_j = (_h = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _h === void 0 ? void 0 : _h.immersiveBizchatM365AppSessionIdChangeEnabled) !== null && _j !== void 0 ? _j : false;
    if (passSessionId) {
        bizchatCopilotUrl = bizchatCopilotUrl.replace('{sessionId}', 'sessionId={appSessionId}&');
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('{sessionId}', 'sessionId={appSessionId}&');
    }
    else {
        bizchatCopilotUrl = bizchatCopilotUrl.replace('{sessionId}', '');
        bizchatNonCopilotUrl = bizchatNonCopilotUrl.replace('{sessionId}', '');
    }
    switch (copilotMode) {
        case undefined:
        case 'ModeA': {
            if (isCopilotPath()) {
                return bizchatCopilotUrl;
            }
            else {
                return bizchatNonCopilotUrl;
            }
        }
        case 'ModeB': {
            return bizchatCopilotUrl;
        }
        default: {
            return bizchatNonCopilotUrl;
        }
    }
}
function isCopilotPath() {
    return window.location.pathname.toLowerCase().startsWith('/copilot');
}
function getReferrer() {
    const curHref = window.location.href.toLowerCase();
    for (const [key, value] of Object.entries(referrerHostUrls)) {
        if (curHref.includes(key)) {
            return value;
        }
    }
    return defaultReferrer;
}
function removeParams(paramKeys, bizchatCopilotUrl, bizchatNonCopilotUrl) {
    const replaceParams = (url) => {
        paramKeys.forEach((key) => {
            url = url.replace(key, '');
        });
        return url;
    };
    return [
        replaceParams(bizchatCopilotUrl),
        replaceParams(bizchatNonCopilotUrl),
    ];
}
function addParams(paramKeys, paramValues, bizchatCopilotUrl, bizchatNonCopilotUrl) {
    if (paramKeys.length !== paramValues.length) {
        throw new Error('paramKey and paramValue should have the same length');
    }
    const replaceParams = (url) => {
        paramKeys.forEach((key, index) => {
            url = url.replace(key, `${paramValues[index]}&`);
        });
        return url;
    };
    return [
        replaceParams(bizchatCopilotUrl),
        replaceParams(bizchatNonCopilotUrl),
    ];
}
//# sourceMappingURL=getCopilotBaseUrl.js.map